export const COVERSION_RULES = {
    W: { convert: (value) => value / 1000, newUnit: 'kW' },
    kWh: { convert: (value) => value / 1000, newUnit: 'MWh' },
    VA: { convert: (value) => value / 1000, newUnit: 'kVA' },
};
export function convertValue(value, unit) {
    if (COVERSION_RULES[unit]) {
        const { convert, newUnit } = COVERSION_RULES[unit];
        return { value: convert(value), unit: newUnit };
    }
    return { value, unit }; // si no hay regla, mantiene original
}